"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_property_decorator_1 = require("vue-property-decorator");
const bmk_ui_framework_1 = require("@biomemakers/bmk_ui_framework");
const floating_vue_1 = require("floating-vue");
const lucide_vue_next_1 = require("lucide-vue-next");
const SubclientsAvatar_vue_1 = __importDefault(require("./SubclientsAvatar.vue"));
const SubclientsListItem_vue_1 = __importDefault(require("./SubclientsListItem.vue"));
const SubclientController_1 = __importDefault(require("../Modules/Common/controllers/SubclientController"));
const LoadingText_vue_1 = __importDefault(require("./LoadingText.vue"));
let SubclientsSwitcher = class SubclientsSwitcher extends vue_property_decorator_1.Vue {
    constructor() {
        super(...arguments);
        this.controller = new SubclientController_1.default();
        this.subclientsFilters = [];
        this.isDisplayModalSubclients = false;
        this.isDisplayFloatingPanelSubclients = false;
        this.subclientChange = null;
        this.noCrop = false;
        this.loaderSearch = false;
        this.isPanelFilterCrop = false;
        this.textSearch = null;
    }
    created() {
        this.callSubclients();
    }
    openPanelFilter() {
        this.isPanelFilterCrop = !this.isPanelFilterCrop;
    }
    async callSubclients() {
        await this.controller.fetchAllSubclients('/biomemakers-subclients/data/subclients');
    }
    get getSubclients() {
        const subclient = this.controller.allSubclients.filter((item) => item.sub_client.id !== this.currentSubclient.id);
        this.subclientsFilters = subclient.reverse();
        return subclient.reverse();
    }
    get topCrops() {
        const onlyCrops = this.controller.allSubclients
            .map((sc) => sc.crop)
            .flat()
            .map((c) => {
            return {
                crop: c.name,
                logo: c.logo_name,
            };
        });
        const cropAppearances = onlyCrops.reduce((obj, crop) => {
            if (obj[crop.crop] === undefined) {
                obj[crop.crop] = { logo: crop.logo, occurrences: 1 };
            }
            else {
                obj[crop.crop].occurrences++;
            }
            return obj;
        }, {});
        let cropAppearancesSort = Object.entries(cropAppearances).map((key) => {
            return {
                crop: key[0],
                logo: key[1].logo,
                num: key[1].occurrences,
            };
        });
        // @ts-ignore
        cropAppearancesSort = cropAppearancesSort.sort((a, b) => b.num - a.num);
        return cropAppearancesSort.slice(0, 3);
    }
    searchCrop(cropSearchText) {
        this.textSearch = cropSearchText;
        this.onSearchChange(cropSearchText);
    }
    displayFloatingPanelSubclients(value) {
        this.isDisplayFloatingPanelSubclients = value;
    }
    closeModalAction() {
        this.isDisplayModalSubclients = false;
        this.isDisplayFloatingPanelSubclients = false;
    }
    actionSubclientListItem(value, subclient, crop) {
        this.noCrop = false;
        this.isDisplayModalSubclients = value;
        this.isDisplayFloatingPanelSubclients = false;
        this.subclientChange = subclient;
        if (crop === 'no_crop') {
            this.noCrop = true;
            this.changeNameCrop = this.currentCrop;
        }
        else {
            this.changeNameCrop = crop;
        }
    }
    onSearchChange(f) {
        this.loaderSearch = true;
        if (f.length > 0) {
            this.subclientsFilters = this.getSubclients
                .filter((subclient) => subclient.sub_client.c_wineseq
                .toUpperCase()
                .includes(f.toUpperCase()) ||
                subclient.sub_client.nombre_comercial
                    .toUpperCase()
                    .includes(f.toUpperCase()) ||
                this.filterCrops(subclient, f))
                .map((sam) => sam);
        }
        else {
            this.subclientsFilters = this.getSubclients;
        }
        setTimeout(() => {
            this.loaderSearch = false;
        }, 500);
    }
    filterCrops(subclient, textSearch) {
        for (const crop of subclient.crop) {
            if (crop.name.toUpperCase().includes(textSearch.toUpperCase())) {
                return true;
            }
        }
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: String,
        default: 'https://bmk-public-assets.s3.amazonaws.com/bmk-ui-framework/profile/default.jpg',
    })
], SubclientsSwitcher.prototype, "imgSrc", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: 'right' })
], SubclientsSwitcher.prototype, "orientation", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: 'l' })
], SubclientsSwitcher.prototype, "size", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Object, default: null })
], SubclientsSwitcher.prototype, "currentSubclient", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: null })
], SubclientsSwitcher.prototype, "currentCrop", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: '' })
], SubclientsSwitcher.prototype, "redirection", void 0);
SubclientsSwitcher = __decorate([
    (0, vue_property_decorator_1.Options)({
        name: 'SubclientsSwitcher',
        components: {
            Dropdown: floating_vue_1.Dropdown,
            XCircle: lucide_vue_next_1.XCircle,
            List: bmk_ui_framework_1.List,
            ListItem: bmk_ui_framework_1.ListItem,
            SubclientsListItem: SubclientsListItem_vue_1.default,
            Modal: bmk_ui_framework_1.Modal,
            Button: bmk_ui_framework_1.Button,
            SubclientsAvatar: SubclientsAvatar_vue_1.default,
            ChevronsRight: lucide_vue_next_1.ChevronsRight,
            ViewZero: bmk_ui_framework_1.ViewZero,
            WarningRoundedIcon: bmk_ui_framework_1.WarningRoundedIcon,
            Loading: bmk_ui_framework_1.Loading,
            LoadingText: LoadingText_vue_1.default,
            XRoundedIcon: bmk_ui_framework_1.XRoundedIcon,
            ArrowRightIcon: bmk_ui_framework_1.ArrowRightIcon,
            Search: bmk_ui_framework_1.Search,
            Tag: bmk_ui_framework_1.Tag,
            MagnifyingGlassIcon: bmk_ui_framework_1.MagnifyingGlassIcon,
            Filter: lucide_vue_next_1.Filter,
        },
    })
], SubclientsSwitcher);
exports.default = SubclientsSwitcher;
